module.exports = __webpack_public_path__ + "img/brown-wooden-table-with-chair-3097112.7af199e9.jpg";